import { ReactNode } from 'react';

import { useLocation } from 'react-router';

import styles from './GenericLayout.module.css';
import { UK_DIRECT_BASE_OB_LINK_PATHNAME } from '../../../constants';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import PoweredByIwoca from '../../PoweredByIwoca/PoweredByIwoca';
import { OpenBankingFAQ } from '../../SidePanel/Content/OpenBankingFAQ';
import Help from '../../SidePanel/Help/Help';
import SidePanel from '../../SidePanel/SidePanel';
import TrustPilot from '../../TrustPilot/TrustPilot';

export const GenericLayout = ({ children }: { children: ReactNode }) => {
  const { isMobile } = useWindowDimensions();
  const { pathname } = useLocation();

  return (
    <div>
      {!isMobile && <SidePanel />}
      <div className={styles.container}>
        <div className={styles.content}>{children}</div>
      </div>

      {isMobile && (
        <>
          {pathname.includes(UK_DIRECT_BASE_OB_LINK_PATHNAME) && (
            <OpenBankingFAQ isMobile />
          )}
          <hr className={styles.footerBreak} />
          <div className={styles.footer}>
            <Help expanded />
            <div>
              <PoweredByIwoca />
              <TrustPilot />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
